import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';

import CardPackage from '../components/CardPackage';

import { packages } from '../raw/pricing';

const PricingPage = () => {
  return (
    <>
      <Container maxWidth="sm" component="main">
        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
          {`Paquetes`}
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          {`Los timbres no tienen una fecha de vigencia o expiracion.`}
        </Typography>
      </Container>

      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {packages.map((pack, index) =>
            <Grid item key={index} xs={12} sm={6} md={4}>
              <CardPackage {...pack} />
            </Grid>
          )}
          <Grid item sx={12} sm={12} md={12}>
            <CardPackage quantity="+5000" info="Contactanos para mas detalles" button="Contactar" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default PricingPage;
